import { clearViewportTransientOverlays } from "../../sceneViewportCleanup";
import { releaseAndDisposeSceneObjectTree } from "../../scene/sceneDispose";
import { clearRuntimeRegistry, hidePosPickMarker } from "./sceneRebuildShared";

export function clearSceneForEmptyModel({
  currentFileKeys,
  fileMapSignatureRef,
  jointLabelRefs,
  newFileMapSig,
  previousFileMapKeysRef,
  removedBodyCacheRef,
  sceneObjectsRef,
  sceneRef,
  setSceneObjects,
  siteLabelsRef,
}) {
  clearViewportTransientOverlays(sceneRef.current);

  const existingModel = sceneRef.current.getObjectByName("modelGroup");
  if (existingModel) {
    releaseAndDisposeSceneObjectTree(existingModel);
    sceneRef.current.remove(existingModel);
  }

  jointLabelRefs.current = {};
  siteLabelsRef.current = {};
  sceneObjectsRef.current = {};
  Object.values(removedBodyCacheRef.current || {}).forEach((obj) => {
    releaseAndDisposeSceneObjectTree(obj);
  });
  removedBodyCacheRef.current = {};

  hidePosPickMarker(sceneRef.current);
  setSceneObjects({});
  clearRuntimeRegistry();

  fileMapSignatureRef.current = newFileMapSig;
  previousFileMapKeysRef.current = currentFileKeys;
}
